// src/components/Footer.js
import React from 'react';

const Footer = () => (
  <footer className="footer" id="footer">
    <p>&copy; 2024 Her Cycle. All rights reserved.</p>
    {/* <h5>Made with ❤️</h5> */}
  </footer>
);

export default Footer;
